import { render, staticRenderFns } from "./sw-qsg-modal-footer.vue?vue&type=template&id=53c5b8a1&"
import script from "./sw-qsg-modal-footer.vue?vue&type=script&lang=ts&"
export * from "./sw-qsg-modal-footer.vue?vue&type=script&lang=ts&"
import style0 from "./sw-qsg-modal-footer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports